<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="grid-wrapper">
      <breadcrumb />
      <span />
      <div class="navbar-right-wrapper">

        <div class="shuoming-btn wendang" @click="downLoadFile('wd')">
          <svg-icon class="shuoming-icon" icon-class="nav-wd"></svg-icon>
          <div class="shuoming-text">操作说明(文档)</div>
        </div>
        <div class="shuoming-btn shipin" @click="downLoadFile('sp')">
          <svg-icon class="shuoming-icon" icon-class="nav-sp"></svg-icon>
          <div class="shuoming-text">操作说明(视频)</div>
        </div>

        <qr-code />

        <div class="fg-line"></div>

        <div class="user-info-box" @click="editUserInfo" >
          <svg-icon icon-class="user-icon" class="user-icon"></svg-icon>
          <div class="text">
            <div class="username">{{username}}</div>
            <div class="name">{{name}}</div>
          </div>
          <svg-icon icon-class="icon-right-more" class="icon-right-more"></svg-icon>
        </div>

        <div class="fg-line"></div>



        <div class="principal-wrapper" >
          <el-dropdown trigger="click">
            <div class="avatar-wrapper">更多操作<svg-icon icon-class="icon-down-more" class="icon-right-more" style="margin-left: 8px;"></svg-icon></div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
              <router-link class="inlineBlock" to="/">
                <el-dropdown-item>首页</el-dropdown-item>
              </router-link>
              <el-dropdown-item divided>
                <span  @click="editUserInfo" style="display: block">修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <span @click="logout" style="display: block">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

  </el-menu>
</template>

<script>
import logo_icon from "@/assets/images/logo.png";
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import QrCode from "./QrCode.vue";

const defaultAdmin = {
    id: null,
    username: null,
    password: null,
    nickName: null,
    email: null
  };
export default {
  data() {
    return {
      logo_icon,
      admin: Object.assign({}, defaultAdmin),
      userDialogVisible:true
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
    QrCode,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar","name","username"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    editUserInfo(){
      this.$router.push({ path: "/users/personal" });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    downLoadFile(val){
      if(val == 'wd'){
       window.open('https://gkzppt.com/public/help_manual.zip', '_blank');
      }
      if(val == 'sp'){
       window.open('https://gkzppt.com/public/help_video.zip', '_blank');
      }
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  top: 0px;
  line-height: 60px;
  border-radius: 0px !important;
  position: fixed;
  top: 0;
  left: 180px;
  right: 0;
  z-index: 9;
  background: linear-gradient(90deg, #F5F7FA 0%, #4E55C1 100%);
  border-bottom: none;
  .fg-line{
    width: 1px;
    height: 22px;
    background-color: rgba(255,255,255,0.3);
    margin: auto 30px;
  }
  .grid-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .navbar-right-wrapper{
      display: flex;
      align-items: center;
      .user-info-box{
        display: flex;
        align-items: center;
        cursor: pointer;
        .user-icon{
          width: 40px;
          height: 40px;
        }
        .icon-right-more{
          width: 20px;
          height: 20px;
        }
        .text{
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: center;
          margin-left: 10px;
          margin-right: 10px;
          .username{
            line-height: 1;
            font-size: 14px;
            color: #ebecff;
          }
          .name{
            line-height: 1;
            font-size: 12px;
            color: #cdd0ff;
            margin-top: 6px;
          }
        }
      }
    }
  }
  .hamburger-container {
    line-height: 60px;
    height: 60px;
    float: left;
    padding: 0 10px;
  }
  .qrcode-wrapper {
    .label {
      float: left;
      line-height: 40px;
      padding-right: 5px;
    }
    .qrcode-svg {
      height: 30px;
      width: 30px;
      vertical-align: 0em;
      cursor: pointer;
    }
  }
  .principal-wrapper {
    display: flex;
    align-items: center;
    .label {
      line-height: 40px;
      color:rgb(63, 62, 62);
    }
  }

  .avatar-wrapper {
    cursor: pointer;
    margin-right: 30px;
    color: #ebecff;
    font-size: 14px;
    line-height: 1;
    .user-avatar {
      width: 40px;
      height: 40px;
    }
    .el-icon-caret-bottom {
      font-size: 22px;
    }
  }
}
.user-dropdown{
    min-width: 120px;
    margin-top: 36px;
}

.shuoming-btn{
  height: 34px;
  display: flex;
  align-items: center;
  border-radius: 99px;
  padding: 15px;
  margin-right: 10px;
  cursor: pointer;
  flex-wrap: nowrap;
  min-width: 70px;
  .shuoming-icon{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .shuoming-text{
    font-size: 12px;
    line-height: 1;
  }
}
.shuoming-btn.wendang{
  background-color: #d3f1e1;
  .shuoming-text{
    color: #17944f;
  }
}
.shuoming-btn.shipin{
  background-color: #fff6eb;
  .shuoming-text{
    color: #e47207;
  }
}

@media (max-width:1366px) {
  .shuoming-btn{
    height: 34px;
    display: flex;
    align-items: center;
    border-radius: 99px;
    padding: 6px;
    margin-right: 4px;
    cursor: pointer;

    .shuoming-icon{
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    .shuoming-text{
      font-size: 12px;
    }
}
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue